import { request } from './client';
import type { FxRateView } from './generated';

export interface FxRate {
  id: number;
  base: string;
  quote: string;
  rate: string;
  asOf: string;
  source: string;
  fetchedAt: string;
}

export function normalizeFxRates(value: readonly FxRateView[]): FxRate[] {
  return value.map((row) => ({
    id: row.id,
    base: row.base,
    quote: row.quote,
    rate: String(row.rate),
    asOf: row.asOf,
    source: row.source,
    fetchedAt: row.fetchedAt,
  }));
}

export const fxRatesApi = {
  async list(query: {
    base: string;
    quote: string;
    from?: string;
    to?: string;
  }): Promise<FxRate[]> {
    return normalizeFxRates(await request<FxRateView[]>('GET', '/v1/me/fx-rates', { query }));
  },
};
